import { Card } from '@/components/Card';

const statColorClass = {
  default: 'text-gray-900',
  positive: 'text-green-600',
  negative: 'text-red-600',
  amber: 'text-amber-600',
};

type Props = {
  compact?: boolean;
  statColor?: keyof typeof statColorClass;
  title: string;
  stat: string | number;
  subtitle: string;
  tag?: React.ReactNode;
  className?: string;
};

export function StatCard({ compact, statColor = 'default', title, stat, subtitle, tag, className }: Props) {
  return (
    <Card className={compact ? `p-3 ${className ?? ''}` : className}>
      <p className="text-[10px] font-semibold uppercase tracking-widest text-[#9295A5]">{title}</p>
      <p className={`font-semibold ${statColorClass[statColor]} ${compact ? 'mt-1 text-lg' : 'mt-2 text-2xl'}`}>
        {stat}
      </p>
      <p className="mt-1 text-xs text-gray-500">{subtitle}</p>
      {tag && <div className="mt-1 truncate">{tag}</div>}
    </Card>
  );
}
